import React from "react";

import cls from "../../../utils/cls";
import Headline from "../Headline";
import FullShape from "./FullShape";
import ShapeCorner from "./ShapeCorner";
import ShapePartLeft from "./ShapePartLeft";
import ShapePartRight from "./ShapePartRight";
import * as styles from "./style.module.scss";

const ShapeContainer = ({
    children,
    className,
    color = "#f0f0f0",
    origin = "left",
    type = "default",
}) => {
    return (
        <div
            className={cls(
                styles.shapeContainer,
                className,
                origin === "left" ? styles.originLeft : styles.originRight,
                styles[type]
            )}
        >
            <div className={styles.shapeContent}>{children}</div>

            {type === "default" && (
                <div className={styles.flyingShapeContainer}>
                    <FullShape color={color} />
                </div>
            )}

            {type === "full-size" && (
                <div className={styles.fullSizeShapeContainer}>
                    <div
                        className={styles.fullSizeShapeFill}
                        style={{ backgroundColor: color }}
                    />
                    <div className={styles.fullSizeShapeLeft}>
                        <ShapePartLeft color={color} />
                    </div>
                    <div className={styles.fullSizeShapeRight}>
                        <ShapePartRight color={color} />
                    </div>
                </div>
            )}

            <div>
                <div className={cls(styles.mobileShape, styles.top)}>
                    <div className={styles.corner}>
                        <ShapeCorner color={color} />
                    </div>
                    <div
                        className={styles.fill}
                        style={{ backgroundColor: color }}
                    />
                </div>

                <div
                    className={cls(styles.mobileShape, styles.center)}
                    style={{ backgroundColor: color }}
                />

                <div className={cls(styles.mobileShape, styles.bottom)}>
                    <div className={styles.corner}>
                        <ShapeCorner color={color} />
                    </div>
                    <div
                        className={styles.fill}
                        style={{ backgroundColor: color }}
                    />
                </div>
            </div>
        </div>
    );
};

const ContainerHeadline = ({ children, className }) => {
    return (
        <Headline className={cls(styles.containerHeadline, className)}>
            {children}
        </Headline>
    );
};

ShapeContainer.Headline = ContainerHeadline;

export default ShapeContainer;
